import React, { useEffect, useState } from "react";
import NetaqInput from "./NetaqInput";
import SubmitBtn from "./SubmitBtn";
import dayjs, { Dayjs } from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { FetchStudBookCountriesthunk } from "../Redux/StudBook/StudBookAction";
import { useTranslate } from "./TranslationText";
import Select from "react-select";
import NewActionButton from "./ActionButtons/NewActionButton";
import { filterButtonsContainer, filterCard, filterHeader, filterResetBtn, filterSubmitBtn } from "../common/cssclasses";
import axiosInstance from "../axios/axios";
const isTestApp = process.env.REACT_APP_IS_TEST;

const StudBookFilter = ({ onSubmit, regNo, setRN }) => {
  const { studBookCountries, currentLanguage } = useSelector(
    (state) => state.studBookSlice
  );

  const dispatch = useDispatch();
  const { translate } = useTranslate();
  const [bestHorses, setBestHorses] = useState(false)
  useEffect(() => {
    dispatch(FetchStudBookCountriesthunk(currentLanguage));
    getShowsCategories();

  }, [currentLanguage]);

  const [birthDateFrom, setBirthdateFrom] = useState(null);
  const [birthDateTo, setBirthdateTo] = useState(null);
  const [showRangeFrom, setShowRangeFrom] = useState(dayjs().subtract(1, "year"));
  const [showRangeTo, setShowRangeTo] = useState(dayjs());
  const [showsCategories, setShowsCategories] = useState();
  const [searchWay, setSearchWay] = useState({
    label: translate('web.bestHorsesWay', 'bestHorsesWay'),
    text: translate('web.bestHorsesWay', 'bestHorsesWay'),
    value: "BestWay"
  });
  const [selectedBestHorse, setSelectedBestHorse] = useState({
    label: translate('web.thehorse', 'horse'),
    text: translate('web.thehorse', 'horse'),
    value: "Horse"
  },);
  const [selectedCategories, setSelectedShowsCategories] = useState([]);
  const [selectedMedals, setSelectedMedals] = useState([]);

  const [filterState, setFilterState] = useState({
    gender: [],
    registrationNumber: regNo,
    origin: null,
    originDrop: {
      label: translate("web.chooseOrigin", "Choose Origin"),
      value: null,
    },
    ownerId: "",
    birthDateFrom: null,
    birthDateTo: null,
    IsBestSearch: false,
    HorseSearchType: selectedBestHorse?.value,
    ShowsFrom: showRangeFrom?.$d?.toISOString(),
    ShowsTo: showRangeTo.$d?.toISOString(),
    ShowRankIds: [],
    SearchWay: searchWay?.value,
    RankFrom: 1,
    RankTo: 10,
    MedalsList: null,
  });



  const handleChange = (event, input) => {

    if (!!input && input === "birthDateFrom") {
      setBirthdateFrom(event)
      setFilterState({
        ...filterState,
        birthDateFrom: event.$d.toISOString(),
      });
      return;
    }
    if (!!input && input === "birthDateTo") {
      setBirthdateTo(event)
      setFilterState({
        ...filterState,
        birthDateTo: event.$d.toISOString(),
      });
      return;
    }
    if (!!input && input === "origin") {
      setFilterState({
        ...filterState,
        origin: event.value,
        originDrop: event,
      });
      return;
    }

    if (event.target.name !== "gender") {
      setFilterState({
        ...filterState,
        [event.target.name]: event.target.value,
      });
    }
    if (event.target.name === "registrationNumber") {
      setRN(event.target.value);
    }

    if (event.target.name === "gender") {
      if (!event.target.checked) {
        setFilterState({
          ...filterState,
          gender: filterState.gender.filter(
            (item) => item !== parseInt(event.target.value)
          ),
        });
      } else {
        setFilterState({
          ...filterState,
          gender: filterState.gender.concat(parseInt(event.target.value)),
        });
      }
    }
  };

  const handleSubmit = (event) => {
    window.scrollTo(0, 0);
    event.preventDefault();
    onSubmit(filterState); // Pass filter state to auctionPage
  };

  const handleReset = (event) => {
    setBirthdateFrom(null)
    setBirthdateTo(null)
    setRN("");
    setFilterState({
      gender: [],
      horseUELN: "",
      origin: null,
      originDrop: {
        label: translate("web.chooseOrigin", "Choose Origin"),
        value: null,
      },
      ownerId: "",
      birthDateFrom: null,
      birthDateTo: null,
    });
  };


  const bestHorseOptions = [
    {
      label: translate('web.thehorse', 'horse'),
      text: translate('web.thehorse', 'horse'),
      value: "Horse"
    },
    {
      label: translate('web.sire', 'sire'),
      text: translate('web.sire', 'sire'),
      value: "Sire"
    },
    {
      label: translate('web.dam', 'dam'),
      text: translate('web.dam', 'dam'),
      value: "Dam"
    },
  ]


  const searchWayOptions = [
    {
      label: translate('web.bestHorsesWay', 'bestHorsesWay'),
      text: translate('web.bestHorsesWay', 'bestHorsesWay'),
      value: "BestWay"
    },
    {
      label: translate('web.rankWay', 'rankWay'),
      text: translate('web.rankWay', 'rankWay'),
      value: "RankWay"
    },
    {
      label: translate('web.medalWay', 'medalWay'),
      text: translate('web.medalWay', 'medalWay'),
      value: "MedalWay"
    },
  ]
  const medals = [
    {
      label: translate('web.gold', 'gold'),
      text: translate('web.gold', 'gold'),
      value: "Gold"
    },
    {
      label: translate('web.Silver', 'Silver'),
      text: translate('web.Silver', 'Silver'),
      value: "Silver"
    },
    {
      label: translate('web.Bronze', 'Bronze'),
      text: translate('web.Bronze', 'Bronze'),
      value: "Bronze"
    },
  ]


  async function getShowsCategories() {
    try {
      const res = await axiosInstance.get('/lookup/getshowranks');
      if (res.data?.responseCode == "200") {
        const formattedData = res.data?.result?.map((x) => ({
          label: x?.showRankName,
          text: x?.showRankName,
          value: x?.id,
        }))
        setShowsCategories(formattedData);
      } else {
        setShowsCategories([]);
      }

    } catch (error) {
      console.error('Error in Ranks', error)
    }

  }


  return (
    <form
      className={filterCard}
      onSubmit={handleSubmit}
      onReset={handleReset}
    >
      <h2 className={filterHeader}>{translate('web.advancedSearch', 'Advanced Search')}</h2>
      <div className="mb-form-group">
        <NetaqInput
          name={"registrationNumber"}
          label={translate("web.horseNameNumber", "Horse Name | Number")}
          placeholder={translate("web.horseNameNumber", "Horse Name | Number")}
          type={"text"}
          value={regNo}
          onChange={handleChange}
        />
      </div>
      <div className="mb-form-group">
        <NetaqInput
          name={"ownerId"}
          label={translate("web.ownerNameOrNumber", "Owner Name | Number")}
          placeholder={translate("web.ownerNameOrNumber", "Owner Name | Number")}
          type={"text"}
          onChange={handleChange}
        />
      </div>
      <div className="mb-form-group">
        <label className="">{translate("web.gender", "Gender")}</label>
        <div className="AuctionFilterNumberofhoursesContainer" style={{ flexWrap: 'wrap' }}>
          <NetaqInput
            name={"gender"}
            type={"checkbox"}
            value={1}
            label={translate("web.mare", "Mare")}
            onChange={handleChange}
          />

          <NetaqInput
            name={"gender"}
            type={"checkbox"}
            value={2}
            label={translate("web.stallion", "Stallion")}
            onChange={handleChange}
          />

          <NetaqInput
            name={"gender"}
            type={"checkbox"}
            value={3}
            label={translate("web.gelding", "Gelding")}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="mb-form-group">
        <div className="row">
          <div className="col-6">
            <NetaqInput
              name={"birthDateFrom"}
              type={"date"}
              label={
                <>
                  {translate("web.birthDate", "Birthdate")} {translate("web.from", "From")}
                </>
              }
              onChange={handleChange}
              value={birthDateFrom}
            />
          </div>
          <div className="col-6">
            <NetaqInput
              name={"birthDateTo"}
              type={"date"}
              label={
                <>
                  {translate("web.birthDate", "Birthdate")} {translate("web.to", "To")}
                </>
              }
              onChange={handleChange}
              value={birthDateTo}
              minDate={birthDateFrom}
            />
          </div>
        </div>
      </div>


      <div className="mb-form-group">
        <NetaqInput type={'select'}
          label={translate("web.origin", "Origin")}
          listSelect={[
            {
              label: translate("web.chooseOrigin", "Choose Origin"),
              value: null,
            },
            ...(!!studBookCountries &&
              studBookCountries.map((a) => ({
                label: a.text,
                value: a.value,
              }))),
          ]}
          value={filterState.originDrop}
          onChange={(e) => handleChange(e, "origin")}
          placeholder={translate("web.chooseOrigin", "Choose Origin")}
          name={"origin"}
          noOptionsMessage={() => translate("web.noOptions", "No Options")}
        />
      </div>
      {
        <>
          <div className="dropdown-divider mb-form-group" ></div>
          <div className="mb-form-group">
            <NetaqInput
              name={"bestHorses"}
              type={"checkbox"}
              value={bestHorses}
              checked={bestHorses}
              label={translate("web.findBestHorses", "findBestHorses")}
              onChange={(event) => {
                setBestHorses(event.target.checked);
                setFilterState({
                  ...filterState,
                  IsBestSearch: event.target.checked,
                });
              }}
            />
          </div>
          {bestHorses == true &&
            <>
              <div className="mb-form-group">
                <NetaqInput type={'select'}
                  label={translate("web.searchfor", "Search For")}
                  listSelect={bestHorseOptions}
                  placeholder={translate("web.searchfor", "Search For")}
                  name={"horseSearch"}
                  value={selectedBestHorse}
                  onChange={(selectedItem) => {
                    setSelectedBestHorse(selectedItem);
                    setFilterState({
                      ...filterState,
                      HorseSearchType: selectedItem?.value,
                    });
                  }}
                  noOptionsMessage={() => translate("web.noOptions", "No Options")}
                />
              </div>
              <div className={`mb-form-group`}>
                <NetaqInput type={'select'}
                  label={translate("web.searchWay", "searchWay")}
                  listSelect={searchWayOptions}
                  placeholder={translate("web.searchWay", "searchWay")}
                  onChange={(selected) => {
                    setSearchWay(selected);
                    setFilterState({
                      ...filterState,
                      SearchWay: selected?.value,
                    });
                  }}
                  name={"horseSearch"}
                  value={searchWay}
                  noOptionsMessage={() => translate("web.noOptions", "No Options")}
                />
              </div>
              {searchWay?.value == "RankWay" &&
                <>
                  <div className="mb-form-group-last">
                    <div className="row">
                      <div className="col-6">
                        <NetaqInput
                          name={"RankFrom"}
                          type={"number"}
                          label={
                            <>
                              {translate("web.rank", "rank")} {translate("web.from", "From")}
                            </>
                          }
                          placeholder={'1'}
                          value={1}
                          onChange={handleChange}

                        />
                      </div>
                      <div className="col-6">
                        <NetaqInput
                          name={"RankTo"}
                          type={"number"}
                          label={
                            <>
                              {translate("web.rank", "showRange")} {translate("web.to", "To")}
                            </>
                          }
                          placeholder={'10'}
                          onChange={handleChange}
                          value={10}
                        />
                      </div>
                    </div>
                  </div>
                </>
              }
              {searchWay?.value == "MedalWay" &&
                <>
                  <div className={`mb-form-group-last`}>
                    <NetaqInput type={'select'}
                      label={translate("web.medals", "medals")}
                      listSelect={medals}
                      isClearable
                      isMulti
                      placeholder={translate("web.medals", "medals")}
                      onChange={(selected) => {
                        setSelectedMedals(selected);
                        const values = selected?.map((x) => (x?.value)) ?? [];
                        setFilterState({
                          ...filterState,
                          MedalsList: values,
                        });
                      }}
                      value={selectedMedals}
                      name={"horseSearch"}
                      noOptionsMessage={() => translate("web.noOptions", "No Options")}
                    />
                  </div>
                </>
              }
              <div className="mb-form-group">
                <div className="row">
                  <div className="col-6">
                    <NetaqInput
                      name={"showDateFrom"}
                      type={"date"}
                      label={
                        <>
                          {translate("web.showRange", "showRange")} {translate("web.from", "From")}
                        </>
                      }
                      onChange={(event) => {
                        setShowRangeFrom(event);
                        setFilterState({
                          ...filterState,
                          ShowsFrom: event?.$d?.toISOString(),
                        });
                      }}
                      value={showRangeFrom}
                    />
                  </div>
                  <div className="col-6">
                    <NetaqInput
                      name={"showDateTo"}
                      type={"date"}
                      label={
                        <>
                          {translate("web.showRange", "showRange")} {translate("web.to", "To")}
                        </>
                      }
                      onChange={(event) => {
                        setShowRangeTo(event)
                        setFilterState({
                          ...filterState,
                          ShowsTo: event?.$d?.toISOString(),
                        });
                      }}
                      value={showRangeTo}
                      minDate={showRangeFrom}
                      maxDate={showRangeFrom?.add(5, "year")}
                    />
                  </div>
                </div>
              </div>
              <div className="mb-form-group">
                <NetaqInput type={'select'}
                  label={translate("web.showCategoties", "Show Categoties")}
                  listSelect={showsCategories}
                  isClearable
                  isMulti
                  placeholder={translate("web.showCategoties", "Show Categoties")}
                  name={"horseSearch"}
                  value={selectedCategories}
                  noOptionsMessage={() => translate("web.noOptions", "No Options")}
                  onChange={(selectedItem) => {
                    setSelectedShowsCategories(selectedItem)
                    const values = selectedItem?.map((x) => (x?.value)) ?? [];
                    setFilterState({
                      ...filterState,
                      ShowRankIds: values,
                    });
                  }}
                />
              </div>

            </>
          }
        </>}


      <div className={filterButtonsContainer} >
        <div className={filterResetBtn}>
          <NewActionButton
            key={"reset"}
            isButton
            classNames="btn-outline-secondary"

            type={"reset"}
            text={translate('web.reset', 'Reset')}
          />
        </div>
        <div className={filterSubmitBtn}>
          <NewActionButton
            isButton
            classNames="btn-danger"
            text={translate("web.search", "Search")}
            key={"apply"}
            type={"submit"}
          // disabled={
          //   filterState.gender.length === 0 &&
          //   filterState.origin === null &&
          //   filterState.registrationNumber === "" &&
          //   filterState.ownerId === "" &&
          //   filterState.birthDateFrom === null &&
          //   filterState.birthDateTo === null
          // }
          />
        </div>
      </div>
    </form>
  );
};

export default StudBookFilter;
